export enum adminNewsListTypes {
    FETCH_ADMIN_NEWS_LIST_REQUEST = "FETCH_ADMIN_NEWS_LIST_REQUEST",
    FETCH_ADMIN_NEWS_LIST_SUCCESS = "FETCH_ADMIN_NEWS_LIST_SUCCESS",
    FETCH_ADMIN_NEWS_LIST_FAILURE = "FETCH_ADMIN_NEWS_LIST_FAILURE",
  }